import { type TranslationIDs, useIntl } from '@capsicum/common';
import styled from 'styled-components';

type LoginTimerProps = {
	label: TranslationIDs;
	seconds: number;
};

export const LoginTimer = ({ label, seconds }: LoginTimerProps) => {
	const { $t } = useIntl();

	return (
		<S.Wrapper>
			{$t(label, {
				time: seconds >= 10 ? seconds : `0${seconds}`
			})}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.label`
		margin-bottom: 0;
		text-align: center;
		${({ theme }) => theme.fonts.text.text4};
		margin-top: ${({ theme }) => theme.spacings.xlarge};
		color: ${({ theme }) => theme.colors.text.main.disabled};
	`;
}
